import { render, staticRenderFns } from "./landQuickAppAdd.vue?vue&type=template&id=3a95e3ce&scoped=true"
import script from "./landQuickAppAdd.vue?vue&type=script&lang=js"
export * from "./landQuickAppAdd.vue?vue&type=script&lang=js"
import style0 from "./landQuickAppAdd.vue?vue&type=style&index=0&id=3a95e3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95e3ce",
  null
  
)

export default component.exports